import { render, staticRenderFns } from "./addorganization.vue?vue&type=template&id=864b932a&scoped=true&"
import script from "./addorganization.vue?vue&type=script&lang=js&"
export * from "./addorganization.vue?vue&type=script&lang=js&"
import style0 from "./addorganization.vue?vue&type=style&index=0&id=864b932a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864b932a",
  null
  
)

export default component.exports